import { render, staticRenderFns } from "./confirmationDialog.vue?vue&type=template&id=3a0588d9"
import script from "./confirmationDialog.vue?vue&type=script&lang=js"
export * from "./confirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports